/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../bank-accounts/bank_accounts';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "ImportableExternalBankAccount": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "bankName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "accountNumberSuffix": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "primaryBankIdentificationNumber": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "accountType": {
                        "type": ".squareup.bank_accounts.BankAccountType",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ImportableExternalBankAccount) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a non-SFS Bank Account that is verified and active, and has been linked by a Square merchant
 * for another Square product, but isn't yet linked for usage by SFS. The accounts are stored in the Gringotts service.
 * --
 *
 * SOURCE ImportableExternalBankAccount @ squareup/sfs/external/models/importable_external_bank_account.proto at 13:1
 */
export const ImportableExternalBankAccount = $root.lookupType('squareup.sfs.external.models.ImportableExternalBankAccount');
fixType(ImportableExternalBankAccount, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(ImportableExternalBankAccount);